var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m83.891 42.641h-5.418c-0.69531 0-1.3906-0.55469-1.3906-1.3906v-12.777c0-14.723-11.391-27.223-26.109-27.777-15.418-0.55469-28.195 11.805-28.195 27.223v13.473c0 0.69531-0.55469 1.3906-1.3906 1.3906h-5.418c-2.082 0-3.75 1.668-3.75 3.75v49.168c0 2.082 1.668 3.75 3.75 3.75h67.777c2.082 0 3.75-1.668 3.75-3.75l0.003906-49.309c0.14062-2.0859-1.5273-3.75-3.6094-3.75zm-52.641-14.723c0-10.695 8.8906-19.305 19.723-18.75 10.141 0.55469 17.918 9.168 17.918 19.305v12.918c0 0.69531-0.55469 1.3906-1.3906 1.3906l-35-0.003906c-0.69531 0-1.3906-0.55469-1.3906-1.3906v-13.469z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8e91373833ad0963b95f68cea8bfbe94.svg";
export { ForwardRef as ReactComponent };